export default "__VITE_ASSET__f93e2acb__"